module.exports = __webpack_public_path__ + "static/media/jth_logo.a32889db.png";